import { render, staticRenderFns } from "./RulesupLayout.vue?vue&type=template&id=13b2f130&"
import script from "./RulesupLayout.vue?vue&type=script&lang=js&"
export * from "./RulesupLayout.vue?vue&type=script&lang=js&"
import style0 from "./RulesupLayout.vue?vue&type=style&index=0&id=13b2f130&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/kivateknoloji/kivacloud/corona-ux/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13b2f130')) {
      api.createRecord('13b2f130', component.options)
    } else {
      api.reload('13b2f130', component.options)
    }
    module.hot.accept("./RulesupLayout.vue?vue&type=template&id=13b2f130&", function () {
      api.rerender('13b2f130', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/RulesupLayout.vue"
export default component.exports